import React from "react";


const generateMonthDates = (month, year) => {
  const monthIndex = {
    January: 0,
    February: 1,
    March: 2,
    April: 3,
    May: 4,
    June: 5,
    July: 6,
    August: 7,
    September: 8,
    October: 9,
    November: 10,
    December: 11,
  };

  const date = new Date(year, monthIndex[month], 1);
  const result = [];

  const formatDate = (d) => {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
  };

  while (date.getMonth() === monthIndex[month]) {
    result.push({
      date: formatDate(date), 
      products: [],
      summary: {
        total: 0,
        paid: 0,
        pending: 0,
      },
    });

    date.setDate(date.getDate() + 1);
  }

  return result;
};

export default generateMonthDates;
